package fr.manyverse.app.presentation.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.events.Event

@Composable
actual fun DisableBackNavigation() {
    DisposableEffect(Unit) {
        val body = document.body
        val previousOverscroll = body?.style?.getPropertyValue("overscroll-behavior") ?: ""
        body?.style?.setProperty("overscroll-behavior", "none")

        window.history.pushState(null, "")

        val listener: (Event) -> Unit = { window.history.pushState(null, "") }
        window.addEventListener("popstate", listener)

        onDispose {
            window.removeEventListener("popstate", listener)
            if (previousOverscroll.isEmpty()) {
                body?.style?.removeProperty("overscroll-behavior")
            } else {
                body?.style?.setProperty("overscroll-behavior", previousOverscroll)
            }
        }
    }
}
